module.exports = __webpack_public_path__ + "static/media/certificate-enrolled-2-3.09e9ebe3.svg";